import React, { Component, Fragment } from 'react'
import Loading from '../../../components/Loading'
import Section from '../../../components/Section'
import { getDetail } from '../../../api/profession'
import './index.less'

class ProfessionDetail extends Component {

  constructor(props) {
    super(props)
    const { match } = this.props
    this.state = {
      id: match.params.id,
      detail: null,
      loading: false,
    }
  }
  static defaultProps = {
    isRenderBackBtn: true
  }
  componentDidMount() {
    const { match } = this.props
    this.getDetail(match.params.id)
  }

  getDetail(id) {
    this.setState({ loading: true })
    getDetail(id).then(({ data }) => {
      let div = document.createElement('div')
      let description
      div.innerHTML = data.introduction
      description = div.innerText.match(/^.*?。/)
      data.description = description ? description[0] : div.innerText
      this.setState(() => ({
        detail: data,
        loading: false,
      }))
    }).finally(() => {
      this.setState({ loading: false })
    })
  }

  handleGoBack() {
    const { history } = this.props
    history.push(`/profession/list`)
  }

  render() {
    const { detail, loading } = this.state
    const { isRenderBackBtn } = this.props;
    if (loading) {
      return (
        <div className="major-detail">
          <Loading />
        </div>
      )
    } else {
      if (detail === null) {
        return (
          <div className="major-detail">
            <div>没有对应的专业</div>
          </div>
        )
      } else {
        let list=
            detail.name=='互联网产品经理'?[{name:'计算机科学与技术',id:178},{name:'软件工程',id:145},{name:'电子与计算机工程',id:1160}]:
            detail.name=='证券投资专业人员'?[{name:'金融学',id:1239},{name:'金融工程',id:596}]:
            detail.name=='猎头顾问'?[{name:'人力资源管理',id:625},{name:'应用心理学',id:336},{name:'社会学',id:723}]:
            detail.name=='管理咨询专业人员'?[{name:'人力资源管理',id:625},{name:'工商管理',id:896},]:
            detail.name=='电视主持人'?[{name:'播音与主持艺术',id:234},]: [];
        return (
          <div className="profession-detail">
            <div className="detail-banner">
              <h1>{detail.name}</h1>
              <p className="major-desc" dangerouslySetInnerHTML={{ __html: detail.description }}></p>
            </div>
            <Section>
              <div className="property">
                <p><span>所属类别</span><span>{detail.classify.name}</span></p>
                <p>
                  <span>兴趣代码</span>
                  {detail.interestA && <i>A</i>}
                  {detail.interestC && <i>C</i>}
                  {detail.interestE && <i>E</i>}
                  {detail.interestI && <i>I</i>}
                  {detail.interestR && <i>R</i>}
                  {detail.interestS && <i>S</i>}
                </p>
              </div>
            </Section>
            {detail.introduction ? <Section title={`${detail.name}是什么？`}>
              <div className="explanation" dangerouslySetInnerHTML={{ __html: detail.introduction }}></div>
            </Section> : null}
            {detail.content ? <Section title="他们的工作内容是什么？">
              <div className="job-content" dangerouslySetInnerHTML={{ __html: detail.content }}></div>
            </Section> : null}
            {detail.activities ? <Section title="他们通常处理什么问题？" className="transparent">
              <div className="job-activities" dangerouslySetInnerHTML={{ __html: detail.activities }}></div>
            </Section> : null}
            {detail.knowledge || detail.skills ? <Section title="需要具备的知识和工作技能?">
              <div className="job-knowledge-and-skills">
                {detail.knowledge ? <Fragment>
                  <h4>他需要了解的知识：</h4>
                  <div className="job-knowledge" dangerouslySetInnerHTML={{ __html: detail.knowledge }}></div>
                </Fragment> : null}
                {detail.skills ? <Fragment>
                  <h4>他需要具备的工作技能：</h4>
                  <div className="job-skills" dangerouslySetInnerHTML={{ __html: detail.skills }}></div>
                </Fragment> : null}
              </div>
            </Section> : null}
            {detail.requirements ? <Section title="基本从业要求">
              <div className="job-requirements" dangerouslySetInnerHTML={{ __html: detail.requirements }}></div>
            </Section> : null}

            {list.length>0&&
                <Section title="参考对应专业">
                  {
                    list.map((i,index)=>{
                      return <div className='about-major' onClick={()=>{
                        const { history, } = this.props
                        history.push(`/major/detail/${i.id}`)
                      }}>
                        <div className="title">{i.name}</div>
                        <div className="desc">点击了解这个专业</div>
                      </div>
                    })
                  }
                </Section>
            }
            {/* <Section title="下一步，继续解锁">
              <div className="recommendations">
                <p>我们猜你可能会对这些职业感兴趣：</p>
                <div className="recommendation-card">
                  <h3>项目管理人员</h3>
                  <p>点击了解这个职业</p>
                </div>
                <div className="recommendation-card">
                  <h3>生产专家</h3>
                  <p>点击了解这个职业</p>
                </div>
                <button onClick={this.handleGoBack.bind(this)}>返回职业列表</button>
              </div>
            </Section> */}
            {isRenderBackBtn
              ? <Section>
                <div className="recommendations">
                  <button onClick={this.handleGoBack.bind(this)}>返回职业列表</button>
                </div>
              </Section>
              : null
            }
          </div>
        )
      }
    }
  }
}

ProfessionDetail.propTypes = {
}

export default ProfessionDetail



// WEBPACK FOOTER //
// ./src/pages/Profession/Detail/index.js